import React, { useEffect, useState } from 'react';

// We initially used styled-components for styling, but encountered issues with the CSS not being applied correctly
// hence leading to the decision to switch to a CSS file for styling.
// We will revert to styled once we figure out the issue with styled-components.

import "./SkipToQcp.css"; // Ensure the CSS file is imported

const SkipToQcp = () => {
    const [showSkipToQcp, setShowSkipToQcp] = useState("off");
    useEffect (() => {
      setShowSkipToQcp("on");
    }, []);

    const handleClick = (event) => {
      event.preventDefault();
      const targetNextStepButton = document.querySelector(".mobius-actions__next");
      const nextStepButton = document.querySelector(
        ".btn-primary.arrow.qa-next-button.js-next-button",
      );
      const hiddenField = document.createElement("input");
      hiddenField.type = "hidden";
      hiddenField.name = "skip_to_qcp";
      hiddenField.value = "true";

      if (nextStepButton) {
        const form = nextStepButton.closest("form");
        if (form) {
          form.appendChild(hiddenField);
          nextStepButton.click();
        }
      }
      if (targetNextStepButton) {
        targetNextStepButton.click();
        const submitBtn = setInterval(() => {
          const element = document.querySelector('button[type="submit"]');
          if (element) {
            element.removeAttribute("disabled");
            element.classList.remove("--is-disabled");
            element.click();
            clearInterval(submitBtn);
          }
        }, 1000);
        setTimeout(() => {
          clearInterval(submitBtn);
        }, 6000);
      }
    };

  return <>
    <div id="skip-to-qcp-container" className={showSkipToQcp}>
      <button id="skip-to-qcp-button" onClick={handleClick}>
        Skip to QCP
      </button>
    </div>
  </>; 
};

export default SkipToQcp;
